import RewardDetails from "./RewardDetails";

export default RewardDetails;
